module.exports = true;


//////////////////
// WEBPACK FOOTER
// ./node_modules/fbjs/node_modules/core-js/library/modules/$.library.js
// module id = 1315
// module chunks = 0